<template>
    <div class="product-map__filter" :class="{ 'product-map__filter--visible-options': open }">
        <div class="product-map__filter-drop-down bg-grey-800" @click="open = !open">
            <span class="product-map__filter-selected">
                {{ activeCategory ? activeCategory.title : 'Filter by type' }}
            </span>
            <span class="product-map__filter-arrow"></span>
        </div>
        <ul class="product-map__tabs">
            <li
                class="product-map__tab product-map__tab--all"
                :class="{ active: activeCategory === null }"
                @click.prevent="selectCategory(null)"
            >
                ALL
            </li>
            <li
                v-for="category in categories"
                :key="category.slug"
                class="product-map__tab"
                :class="{
                    [`product-map__tab--${category.slug}`]: true,
                    active: activeCategory === category
                }"
                @click.prevent="selectCategory(category)"
            >
                {{ category.title }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        categories: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            open: false,
            activeCategory: null
        };
    },

    // mounted() {
    //     const isDesktop = window.matchMedia('(min-width: 1024px)');
    //     this.open = isDesktop.matches;
    // },

    methods: {
        selectCategory(category) {
            this.activeCategory = category;
            this.close();
            this.$emit('change', category);
        },

        close() {
            this.open = false;
        }
    }
};
</script>
